import axios from "axios";
import {
  GET_VERIFYDETAILS_BY_STUDENTID,
  UPDATE_DATA,
  GET_TOTALFORMFEES_BY_STUDENTID
} from "./types";
const keys = require("../config/keys");

export const getFormVerifyDetailsByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetFormVerifyDetailsByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_VERIFYDETAILS_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const admissionInsertVerifyDetails = data => async dispatch => {
  let isVerifySuccess = false;
  await axios({
    method: "post",
    url:
      keys.ServicePath + "/api/AdmissionForm/AdmissionUpdateFormVerifyDetails",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          isVerifySuccess = true;
          const msg = {
            event: "success",
            action: "add",
            page: "Verify",
            data: res.data.data,
            success: true
          };
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  return isVerifySuccess;
};

export const getAdmissionTotalFormFeesByStudentId = (
  FormGroupID,
  StudentId
) => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAdmissionTotalFormFeesByStudentId?FormGroupID=" +
      FormGroupID +
      "&StudentId=" +
      StudentId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_TOTALFORMFEES_BY_STUDENTID,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};

export const WithoutAdmissionFormFeesDetails = data => async dispatch => {
  // let isVerifySuccess = false;
  await axios({
    method: "post",
    url: keys.ServicePath + "/payment/WithoutAdmissionFormFeesDetails",
    data: data
  })
    .then(res => {
      if (res.data.success) {
        try {
          // isVerifySuccess = true;
          const msg = {
            event: "success",
            action: "add",
            page: "Verify",
            data: res.data.data,
            success: true
          };
          dispatch({ type: UPDATE_DATA, payload: msg });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
  // return isVerifySuccess;
};



// WEBPACK FOOTER //
// ./src/actions/getFormVerifyDetailsByStudentId.js